/*
 * All events
 * - donation_page_entered
 * - oneoff_donation_engaged
 * - regular_donation_engaged
 * - proceed_to_donation_payment
 * - donation_payment_failed
 * - donation_payment_succeeded
 */
class GTMDonationEvents {
  constructor() {
    if (!window.dataLayer) {
      return
    }

    this.client = window.dataLayer
    this.form = document.querySelector("form[data-donation-form]")

    this.buttonElements = document.querySelectorAll("[data-donation-btn]")
    this.buttonElements.forEach(this.processStep.bind(this))

    if (this.form) {
      if (window.localStorage && window.localStorage.getItem("DonationJourney")) {
        this.DonationJourneyResumed()
      } else {
        this.EnterDonationPage()
      }
    } else if (window.parent === window) {
      if (window.parent.document.body.classList.contains("cms") || !document.body.classList.contains("DonationPage")) {
        return
      }

      if (location.pathname.indexOf("/thankyou") >= 0) {
        this.PaymentSucceeded()
      }
    }
  }

  processStep(button) {
    button.addEventListener("click", () => {
      const step = String(button.getAttribute("data-donation-btn"))
      const type = document.querySelector("[name='Type']:checked").value
      const amountOneoff = document.querySelector("input[data-donation-total-oneoff]")
      const amountRegular = document.querySelector("input[data-donation-total-regular]")
      const regularFrequency = document.querySelector("input[name='RecurringPaymentFrequency']:checked")

      // Process step 1
      if (step === "1") {
        if (type == 1 && amountOneoff) {
          const amount = amountOneoff.value

          if (amount) {
            this.OneoffDonationEngaged(amount)
          }
        } else if (type == 2 && amountRegular && regularFrequency) {
          const amount = amountRegular.value
          const frequency = regularFrequency.value

          if (amount && frequency) {
            this.RegularDonationEngaged(amount, frequency)
          }
        }

        return
      }

      // Process step 2
      if (step === "2") {
        const data = {}
        const formData = new FormData(this.form)

        for (const key of formData.keys()) {
          data[key] = formData.get(key)
        }

        return
      }
    })
  }

  EnterDonationPage() {
    const eventLabel = "Donation page entered"
    this.client.push({
      event: "donation_page_entered",
      params: {
        category: "Donation",
        action: "Page Landed",
        label: eventLabel,
        value: {
          pageTitle: document.title,
          pageUrl: location.href,
        },
      },
    })

    if (window.localStorage) {
      window.localStorage.setItem("DonationJourney", eventLabel)
    }
  }

  DonationJourneyResumed() {
    const eventLabel = "Donation journey resumed"
    this.client.push({
      event: "donation_journey_resumed",
      params: {
        value: {
          resumeFrom: window.localStorage.getItem("DonationJourney"),
        },
        category: "Donation",
        action: "Journey Resumed",
        label: eventLabel,
      },
    })

    if (window.localStorage) {
      window.localStorage.setItem("DonationJourney", eventLabel)
    }
  }

  OneoffDonationEngaged(amount) {
    const eventLabel = "One-off donation engaged"
    this.client.push({
      event: "oneoff_donation_engaged",
      params: {
        value: {
          amount: amount,
        },
        category: "Donation - One-off",
        action: "Amount Entered",
        label: eventLabel,
      },
    })

    if (window.localStorage) {
      window.localStorage.setItem("DonationJourney", eventLabel)
    }
  }

  RegularDonationEngaged(amount, frequency) {
    const eventLabel = `Regular donation on a ${frequency} basis engaged`
    this.client.push({
      event: "regular_donation_engaged",
      params: {
        value: amount,
        category: "Donation - Regular",
        action: "Amount & Frequency Entered",
        label: eventLabel,
      },
    })

    if (window.localStorage) {
      window.localStorage.setItem("DonationJourney", eventLabel)
    }
  }

  static ProceedToPayment(amount, office) {
    window.dataLayer = window.dataLayer || []

    const eventLabel = `Paying to ${office}`

    window.dataLayer.push({
      event: "proceed_to_donation_payment",
      params: {
        value: amount,
        category: `Donation - ${GTMDonationEvents.getPaymentType()}`,
        action: "Proceed to Payment",
        label: eventLabel,
      },
    })

    if (window.localStorage) {
      window.localStorage.setItem("DonationJourney", eventLabel)
    }
  }

  static getPaymentType() {
    return !document.querySelector("[name='Type']:checked") ||
      document.querySelector("[name='Type']:checked").value == 1
      ? "One-off"
      : "Regular"
  }

  PaymentSucceeded() {
    const amount = document.querySelector("input[name='donated-amount']").value
    const office = document.querySelector("input[name='donated-to']").value
    const type = document.querySelector("input[name='donation-type']").value

    this.client.push({
      event: "donation_payment_succeeded",
      params: {
        value: amount,
        category: `Donation - ${type}`,
        action: "Payment Succeeded",
        label: `Payment to ${office} is successful`,
      },
    })

    if (window.localStorage && window.localStorage.getItem("DonationJourney")) {
      delete window.localStorage.DonationJourney
    }
  }

  static PaymentFailed(type = "One-off") {
    window.dataLayer = window.dataLayer || []
    const eventLabel = "Payment failed"

    window.dataLayer.push({
      event: "donation_payment_failed",
      Label: eventLabel,
      params: {
        category: `Donation - ${type}`,
        action: "Payment Failed",
        label: eventLabel,
      },
    })

    if (window.localStorage) {
      window.localStorage.setItem("DonationJourney", eventLabel)
    }
  }

  static Dropout() {
    if (window.localStorage && window.localStorage.getItem("DonationJourney")) {
      window.dataLayer = window.dataLayer || []
      const step = window.localStorage.getItem("DonationJourney")
      window.dataLayer.push({
        event: "donation_journey_dropout",
        params: {
          category: "Donation",
          action: "Drop",
          label: `Donation journey dropped out at step: ${step}`,
        },
      })

      delete window.localStorage.DonationJourney
    }
  }
}

export default GTMDonationEvents
